import { useState } from 'react';
import { Car } from 'lucide-react';

interface VehicleImageProps {
  make?: string;
  model?: string;
}

export default function VehicleImage({ make, model }: VehicleImageProps) {
  const [imageError, setImageError] = useState(false);

  const getBrandColor = (brand?: string) => {
    if (!brand) return 'from-primary/20 to-primary/5';
    
    const colors: Record<string, string> = {
      'fiat': 'from-red-500/20 to-red-600/5',
      'ford': 'from-blue-600/20 to-blue-700/5',
      'chevrolet': 'from-yellow-500/20 to-yellow-600/5',
      'toyota': 'from-red-700/20 to-red-800/5',
      'volkswagen': 'from-blue-500/20 to-blue-600/5',
      'honda': 'from-red-600/20 to-red-700/5',
      'hyundai': 'from-gray-600/20 to-gray-700/5',
      'renault': 'from-yellow-400/20 to-yellow-500/5',
      'nissan': 'from-gray-700/20 to-gray-800/5',
      'peugeot': 'from-blue-700/20 to-blue-800/5',
    };
    
    return colors[brand.toLowerCase()] || 'from-primary/20 to-primary/5';
  };

  const getBrandInitials = (brand?: string) => {
    if (!brand) return 'XX';
    return brand.substring(0, 2).toUpperCase();
  };

  if (!make || !model || imageError) {
    return (
      <div className={`w-12 h-12 rounded-lg bg-gradient-to-br ${getBrandColor(make)} flex items-center justify-center flex-shrink-0`}>
        {make ? (
          <span className="text-xs font-bold text-primary">
            {getBrandInitials(make)}
          </span>
        ) : (
          <Car className="h-6 w-6 text-primary" />
        )}
      </div>
    );
  }

  const query = encodeURIComponent(`${make} ${model} 2020 car`);
  const imageUrl = `https://source.unsplash.com/200x200/?${query}`;

  return (
    <img 
      src={imageUrl}
      alt={`${make} ${model}`}
      className="w-12 h-12 rounded-lg object-cover flex-shrink-0"
      onError={() => setImageError(true)}
    />
  );
}
